import { Paragraph } from "../paragraph";

import TermsOfUse from "../../../../assets/privacyPolicyAndTermsOfUse/termsOfUse.png";
import PrivacyPolicy from "../../../../assets/privacyPolicyAndTermsOfUse/privacyPolicy.png";

import "./mainSection.scss";

export const MainSection = ({
  firstTilte,
  secondTilte,
  text,
  secondText,
  type,
}) => {
  return (
    <div className="privacyAndTerms-main-section">
      <div>
        <h1>
          {firstTilte} <br /> {secondTilte}
        </h1>
        <Paragraph text={text} />
        {secondText && <Paragraph text={secondText} />}
      </div>
      <div className="img-container">
        {type === "termsOfUse" && (
          <img src={TermsOfUse} alt={type} className="img-header" />
        )}
        {type === "privacyPolicy" && (
          <img src={PrivacyPolicy} alt={type} className="img-header" />
        )}
      </div>
    </div>
  );
};

export default MainSection;
